import React, { useEffect, useState } from "react";
import StudentAttendanceListing from "./StudentAttendanceListing";
import {
  useGetAllStudentAttendanceCountQuery,
  useGetAllStudentAttendanceCalendarQuery,
  useAssignBatchesStudentByIdQuery,
} from "src/services/StudentServices";
import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const StudentAttendanceListingWrapper = () => {
  const { studentId = "" } = useParams();
  const [studentAttendanceCount, setStudentAttendanceCount] = useState<any>({});
  const [studentAttendanceCalendar, setStudentAttendanceCalendar] =
    useState<any>([]);
  const [startDate, setStartDate] = useState(null);
  const [assginBatchData, setAssginBatchData] = useState([]);
  const { data, isLoading, isFetching } =
    useAssignBatchesStudentByIdQuery(studentId);
  const [selectBatch, setSelectBatch] = useState<any>();

  const {
    data: studentCalendar,
    isLoading: studentCalendarIsLoading,
    isFetching: studentCalendarIsFetching,
  } = useGetAllStudentAttendanceCalendarQuery({
    filterBy: [
      { fieldName: "studentId", value: studentId },
      { fieldName: "batchId", value: selectBatch },
    ],
    dateFilter: { },
  });

  const {
    data: studentCount,
    isLoading: studentCountIsLoading,
    isFetching: studentCountIsFetching,
  } = useGetAllStudentAttendanceCountQuery({
    filterBy: [
      { fieldName: "studentId", value: studentId },
      { fieldName: "batchId", value: selectBatch },
    ],
    dateFilter: {
      startDate: "",
      endDate: "",
    },
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setSelectBatch(data?.data?.batches?.[0]?.batchId);
    }
  }, [isLoading, isFetching, data]);

  useEffect(() => {
    if (!studentCountIsLoading && !studentCountIsFetching) {
      setStudentAttendanceCount(studentCount?.data?.[0]);
    }
  }, [studentCountIsLoading, studentCountIsFetching, studentCount]);

  useEffect(() => {
    if (!studentCalendarIsFetching && !studentCalendarIsLoading) {
      setStudentAttendanceCalendar(studentCalendar?.data);
    }
  }, [
    studentCalendarIsFetching,
    studentCalendar,
    studentCalendarIsLoading,
    selectBatch,
  ]);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setAssginBatchData(data?.data?.batches);
    }
  }, [data, isLoading, isFetching]);

  const batchOptions = assginBatchData?.map((el: any) => {
    return {
      label: el?.name,
      value: el?.batchId,
    };
  });

  return (
    <>
      {(isLoading || isFetching ||studentCalendarIsFetching || studentCalendarIsLoading ) && (
        <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
          <CircularProgress />
        </div>
      )}
      <StudentAttendanceListing
        startDate={startDate}
        setStartDate={setStartDate}
        studentAttendanceCount={studentAttendanceCount}
        studentAttendanceCalendar={studentAttendanceCalendar}
        batchOptions={batchOptions}
        selectBatch={selectBatch}
        setSelectBatch={setSelectBatch}
      />
    </>
  );
};

export default StudentAttendanceListingWrapper;
